const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export default function dateToArr(dateStr) {
  const dateArr = dateStr.split('-');
  return {
    month: months[Number(dateArr[1]) - 1],
    date: dateArr[2],
  };
}
